module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1094.f107a8cb.png";